import {
  createSlice,
  createAsyncThunk,
  createSelector } from
'@reduxjs/toolkit';
import { ApolloClient, gql, NormalizedCacheObject } from '@apollo/client';
import { RootState } from '@src/redux/store';
import * as TYPES from '@src/redux/types';

const GRAPHQL = gql`
  mutation getSignedUrl($data: signedUrlInput!) {
    getSignedUrl(data: $data) {
      url
      filename
      status
      error {
        message
        statusCode
      }
    }
  }
`;

const initialState: TYPES.SignedUrlState = {
  result: null,
  error: null,
  loading: false
};

export const getSignedUrlRequest = createAsyncThunk<
  TYPES.SignedUrl,
  {data: TYPES.SignedUrlInput;},
  {extra: ApolloClient<NormalizedCacheObject>;}>(

  'system_file/get_signed_url',
  async (params: {data: TYPES.SignedUrlInput;}, { extra: client }) => {
    try {
      const response = await client.mutate({
        mutation: GRAPHQL,
        variables: params
      });
      return response.data.getSignedUrl;
    } catch (error) {
      const err = error as {message?: String;statusCode?: String;};
      return Promise.reject({
        message: err.message || 'An error occurred',
        statusCode: err.statusCode || '500'
      });
    }
  }
);

const getSignedUrlSlice = createSlice({
  name: 'get_signed_url',
  initialState: initialState,
  reducers: {
    getSignedUrlClear: (state) => {
      state.result = null;
      state.error = null;
      state.loading = false;
    }
  },
  extraReducers: (builder) => {
    builder.
    addCase(getSignedUrlRequest.pending, (state) => {
      state.result = null;
      state.error = null;
      state.loading = true;
    }).
    addCase(getSignedUrlRequest.fulfilled, (state, action) => {
      state.result = action.payload;
      state.loading = false;
    }).
    addCase(getSignedUrlRequest.rejected, (state, action) => {
      state.error = action.payload as Error || {
        message: 'Failed to fetch',
        statusCode: '500'
      };
      state.loading = false;
    });
  }
});

export const { getSignedUrlClear } = getSignedUrlSlice.actions;

export const getSignedUrl = createSelector(
  (state: RootState) => state.systemFile.getSignedUrl.result,
  (state: RootState) => state.systemFile.getSignedUrl.error,
  (state: RootState) => state.systemFile.getSignedUrl.loading,
  (result, error, loading) => ({
    result,
    error,
    loading
  })
);

export default getSignedUrlSlice.reducer;